import connectionProxy from './connectionProxy'

export const addCabinet = ({ areaId, name }) => {
  return connectionProxy.http.post(`/areas/${areaId}/armarios`, {
    name
  })
}

export const updateCabinet = ({ areaId, id, name }) => {
  return connectionProxy.http.put(`/areas/${areaId}/armarios/${id}`, {
    name
  })
}

export const removeCabinet = ({ areaId, cabinetId }) => {
  return connectionProxy.http.delete(`/areas/${areaId}/armarios/${cabinetId}`)
}

export const getCabinets = areaId => {
  return connectionProxy.http.get(`/areas/${areaId}/armarios`)
}

export const searchCabinetProduct = ({ areaId, term, cabinetId }) => {
  return connectionProxy.http.get(`/areas/${areaId}/armarios/${cabinetId}/produtos/buscar`, {
    params: {
      term
    }
  })
}

export const addCabinetProduct = ({ areaId, productId, cabinetId }) => {
  return connectionProxy.http.post(`/areas/${areaId}/armarios/${cabinetId}/produtos`, {
    product_id: productId
  })
}

export const removeCabinetProduct = ({ areaId, productId, cabinetId }) => {
  return connectionProxy.http.delete(
    `/areas/${areaId}/armarios/${cabinetId}/produtos/${productId}`,
    {
      product_id: productId
    }
  )
}

export const downloadPdf = (areaId, cabinetId) =>
  connectionProxy.http.get(`/armarios/${cabinetId}/download_pdf`, { responseType: 'arraybuffer' })

export const getQrCode = (id) =>
  connectionProxy.http.get(`/armarios/${id}/qr_code`, { responseType: 'arraybuffer' })



// WEBPACK FOOTER //
// ./src/api/incompatibilityAnalysis.js